uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

// Lots nore different noises from this package: http://stack.gl/packages/#hughsk/glsl-noise
#pragma glslify: snoise3 = require(glsl-noise/simplex/3d) 
#pragma glslify: dither = require(glsl-dither/4x4) 

vec3 interpolate3Colors(float v, vec3 color1, vec3 color2, vec3 color3) {
    vec3 result;

    // Normalize v to be between 0 and 1
    v = clamp(v, 0.0, 1.0);

    if(v < 0.5) {
    // Interpolate between color1 and color2
        result = mix(color1, color2, v * 2.0);
    } else {
    // Interpolate between color2 and color3
        result = mix(color2, color3, (v - 0.5) * 2.0);
    }

    return result;
}

vec3 interpolate4Colors(float v, vec3 color1, vec3 color2, vec3 color3, vec3 color4) {
    vec3 result;

    // Normalize v to be between 0 and 1
    v = clamp(v, 0.0, 1.0);

    if(v < 0.33) {
        // Interpolate between color1 and color2
        result = mix(color1, color2, v * 3.0);
    } else if(v < 0.66) {
        // Interpolate between color2 and color3
        result = mix(color2, color3, (v - 0.33) * 3.0);
    } else {
        // Interpolate between color3 and color4
        result = mix(color3, color4, (v - 0.66) * 3.0);
    }

    return result;
}

vec3 interpolate5Colors(float v, vec3 color1, vec3 color2, vec3 color3, vec3 color4, vec3 color5) {
    vec3 result;

    // Normalize v to be between 0 and 1
    v = clamp(v, 0.0, 1.0);

    if(v < 0.25) {
        // Interpolate between color1 and color2
        result = mix(color1, color2, v * 4.0);
    } else if(v < 0.5) {
        // Interpolate between color2 and color3
        result = mix(color2, color3, (v - 0.25) * 4.0);
    } else if(v < 0.75) {
        // Interpolate between color3 and color4
        result = mix(color3, color4, (v - 0.5) * 4.0);
    } else {
        // Interpolate between color4 and color5
        result = mix(color4, color5, (v - 0.75) * 4.0);
    }

    return result;
}

vec3 interpolate6Colors(float v, vec3 color1, vec3 color2, vec3 color3, vec3 color4, vec3 color5, vec3 color6) {
    vec3 result;

    // Normalize v to be between 0 and 1
    v = clamp(v, 0.0, 1.0);

    if(v < 0.2) {
        // Interpolate between color1 and color2
        result = mix(color1, color2, v * 5.0);
    } else if(v < 0.4) {
        // Interpolate between color2 and color3
        result = mix(color2, color3, (v - 0.2) * 5.0);
    } else if(v < 0.6) {
        // Interpolate between color3 and color4
        result = mix(color3, color4, (v - 0.4) * 5.0);
    } else if(v < 0.8) {
        // Interpolate between color4 and color5
        result = mix(color4, color5, (v - 0.6) * 5.0);
    } else {
        // Interpolate between color5 and color6
        result = mix(color5, color6, (v - 0.8) * 5.0);
    }

    return result;
}

void main() {
    // vec2 st = gl_FragCoord.xy / resolution.xy;
    // gl_FragColor = vec4(st.x, st.y, 1.0, 1.0);
    vec2 uv = vUv;
    uv -= 0.5;
    vec2 st = uv * resolution;

    float v = (snoise3(vec3(st * 0.002, time * 0.0005)) + 1.0) * 0.5;
    // v = dither(st * 0.9, v);

    vec3 color1 = vec3(1.0, 0.0, 0.88);
    vec3 color2 = vec3(0.0, 0.38, 1.0);
    vec3 color3 = vec3(0.04, 0.7, 0.9);
    vec3 color4 = vec3(0.0, 1.0, 0.58);
    vec3 color5 = vec3(1.0, 0.93, 0.0);
    vec3 color6 = vec3(1.0, 0.0, 0.15);

    //gl_FragColor = vec4(interpolate3Colors(v, color1, color2, color3), 1.0);
    //gl_FragColor = vec4(interpolate4Colors(v, color1, color2, color3, color4), 1.0);
    //gl_FragColor = vec4(interpolate5Colors(v, color1, color2, color3, color4, color5), 1.0);
    gl_FragColor = vec4(interpolate6Colors(v, color1, color2, color3, color4, color5, color6), 1.0);
    //gl_FragColor = vec4(interpolate6Colors(4.0/6.0, color1, color2, color3, color4, color5, color6), 1.0);

}